function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { GALLERY_CONSTS, processLayouts, addPresetStyles, isSEOMode, utils } from 'pro-gallery-lib';
import { getInnerInfoStyle } from '../../item/itemViewStyleProvider';
import './leanGallery.scss';

var LeanGallery = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LeanGallery, _React$Component);

  function LeanGallery() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.measureIfNeeded = _this.measureIfNeeded.bind(_assertThisInitialized(_this));
    _this.eventsListener = _this.eventsListener.bind(_assertThisInitialized(_this));
    _this.state = {
      itemStyle: {},
      numberOfColumns: 0
    };
    return _this;
  } // #region Lifecycle functions


  var _proto = LeanGallery.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.eventsListener(GALLERY_CONSTS.events.APP_LOADED, {});
    this.measureIfNeeded();
    this.setState({
      numberOfColumns: this.calcNumberOfColumns(this.props)
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.container.galleryWidth !== nextProps.container.galleryWidth) {
      this.measureIfNeeded();
      this.setState({
        numberOfColumns: this.calcNumberOfColumns(nextProps)
      });
    }
  } // #endregion
  // #region Gallery
  ;

  _proto.createGalleryStyle = function createGalleryStyle() {
    var _this$props$styles = this.props.styles,
        gridStyle = _this$props$styles.gridStyle,
        numberOfImagesPerRow = _this$props$styles.numberOfImagesPerRow,
        imageMargin = _this$props$styles.imageMargin,
        cubeImages = _this$props$styles.cubeImages;
    var itemSize = this.calcItemContainerSize();
    var numberOfColumns = gridStyle === GALLERY_CONSTS.gridStyle.SET_ITEMS_PER_ROW ? numberOfImagesPerRow : this.state.numberOfColumns;
    var gridTemplateColumns = numberOfColumns > 0 ? "repeat(" + numberOfColumns + ", 1fr)" : "repeat(auto-fit, minmax(" + itemSize.width + "px, 1fr))";
    return _objectSpread({
      gridTemplateColumns: gridTemplateColumns,
      gridGap: imageMargin + "px"
    }, cubeImages === false ? {
      gridAutoRows: 'minmax(max-content, 1px)',
      gridGap: 0,
      columnGap: imageMargin + "px"
    } : {});
  };

  _proto.calcNumberOfColumns = function calcNumberOfColumns(props) {
    var galleryWidth = props.container.galleryWidth;

    if (!galleryWidth) {
      return 0;
    }

    var itemSize = this.calcItemContainerSize();
    var numOfCols = 1;

    if (props.styles.fixedColumns > 0) {
      numOfCols = props.styles.fixedColumns;
    } else {
      // find the number of columns that makes each column width the closet to the itemSize
      var numOfColsFloat = galleryWidth / itemSize.width;
      var roundFuncs = [Math.floor, Math.ceil];
      var diffs = roundFuncs.map(function (func) {
        return func(numOfColsFloat);
      }) //round to top, round to bottom
      .map(function (n) {
        return Math.round(galleryWidth / n);
      }) //width of each col
      .map(function (w) {
        return Math.abs(itemSize.width - w);
      }); //diff from itemSize

      var roundFunc = roundFuncs[diffs.indexOf(Math.min.apply(Math, diffs))]; //choose the round function that has the lowest diff from the itemSize

      numOfCols = roundFunc(numOfColsFloat) || 1;
    }

    return numOfCols;
  } // #endregion
  // #region Item container
  ;

  _proto.calcItemContainerSize = function calcItemContainerSize(item) {
    var _this$props = this.props,
        styles = _this$props.styles,
        container = _this$props.container;
    var targetItemSize = styles.targetItemSize,
        cubeImages = styles.cubeImages,
        titlePlacement = styles.titlePlacement,
        textBoxHeight = styles.textBoxHeight,
        cubeRatio = styles.cubeRatio,
        imageMargin = styles.imageMargin;
    var itemWidth = container.width > 0 ? Math.min(targetItemSize, container.width) : targetItemSize;
    var itemHeight = itemWidth / cubeRatio;

    if (item && cubeImages === false) {
      var ratio = get(item, 'width') / get(item, 'height');
      itemHeight = Math.round((itemWidth - imageMargin) / ratio);
    }

    if (GALLERY_CONSTS.hasVerticalPlacement(titlePlacement)) {
      itemHeight += textBoxHeight;
    }

    return {
      width: itemWidth,
      height: itemHeight
    };
  };

  _proto.createItemContainerStyle = function createItemContainerStyle(clickable, item) {
    var _this$state$itemStyle = this.state.itemStyle.height,
        height = _this$state$itemStyle === void 0 ? null : _this$state$itemStyle;
    var _this$props$styles2 = this.props.styles,
        imageMargin = _this$props$styles2.imageMargin,
        cubeImages = _this$props$styles2.cubeImages;
    var itemSize = this.calcItemContainerSize(item);
    var noCropStyle = cubeImages === false ? {
      gridRowEnd: "span " + itemSize.height,
      marginBottom: imageMargin + "px",
      height: 'fit-content'
    } : {};
    return _objectSpread(_objectSpread(_objectSpread({}, this.createItemContainerBorder()), height ? {
      height: 'auto'
    } : {
      height: 'auto',
      textAlign: 'center'
    }), {}, {
      cursor: clickable ? 'pointer' : 'default'
    }, noCropStyle);
  };

  _proto.createItemContainerBorder = function createItemContainerBorder() {
    // Set border of the entire Item - including the info text
    var styles = this.props.styles;

    if (styles.imageInfoType === GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND) {
      return {
        borderStyle: 'solid',
        borderWidth: styles.itemBorderWidth,
        borderColor: styles.itemBorderColor.value,
        borderRadius: styles.itemBorderRadius
      };
    }
  } // #endregion
  // #region Image wrapper
  ;

  _proto.createImageWrapperStyle = function createImageWrapperStyle(item) {
    var _this$props$styles3 = this.props.styles,
        cubeType = _this$props$styles3.cubeType,
        cubeImages = _this$props$styles3.cubeImages;

    if (this.state.itemStyle.width && cubeType !== GALLERY_CONSTS.resizeMethods.FIT) {
      var itemSize = this.calcItemContainerSize(item);
      return cubeImages === false ? _objectSpread({}, itemSize) : _objectSpread({}, this.state.itemStyle);
    } else if (!(this.state.itemStyle.width > 0)) {
      return {
        width: '100%',
        height: 'auto'
      };
    }

    var _this$state$itemStyle2 = this.state.itemStyle,
        width = _this$state$itemStyle2.width,
        height = _this$state$itemStyle2.height;
    var imageWidth = get(item, 'width');
    var imageHeight = get(item, 'height');
    var imageRatio = imageWidth / imageHeight;
    var containerRatio = width / height;

    if (imageRatio > containerRatio) {
      //image is wider than container
      var _height = width / imageRatio;

      return {
        width: width,
        height: _height,
        marginTop: (height - _height) / 2
      };
    } else {
      var _width = height * imageRatio;

      return {
        height: height,
        width: _width,
        marginLeft: (width - _width) / 2
      };
    }
  } // #endregion
  // #region Image
  ;

  _proto.resizeUrl = function resizeUrl(_ref) {
    var item = _ref.item;
    var _this$props2 = this.props,
        styles = _this$props2.styles,
        resizeMediaUrl = _this$props2.resizeMediaUrl;
    var cubeType = styles.cubeType,
        imageQuality = styles.imageQuality,
        cubeRatio = styles.cubeRatio,
        cubeImages = styles.cubeImages;
    var itemStyle = this.state.itemStyle;
    var url = item.url,
        mediaUrl = item.mediaUrl,
        src = item.src;
    var itemUrl = url || mediaUrl || src;
    var itemSize = this.calcItemContainerSize(item);
    var width = cubeImages === true && itemStyle.width || itemSize.width;
    var height = cubeImages === true && itemStyle.height || itemSize.height / cubeRatio;
    var focalPoint = false;
    var isPreload = !(itemStyle.width > 0);
    var options = isPreload ? {
      quality: 30,
      blur: 30
    } : {
      quality: imageQuality
    };

    if (typeof resizeMediaUrl === 'function') {
      try {
        return resizeMediaUrl({
          maxWidth: get(item, 'width'),
          maxHeight: get(item, 'height')
        }, itemUrl, cubeType, width, height, options, false, focalPoint) || '';
      } catch (e) {
        return String(itemUrl);
      }
    } else {
      return String(itemUrl);
    }
  };

  _proto.createImageStyle = function createImageStyle(imageWrapperStyle) {
    var _imageWrapperStyle$wi = imageWrapperStyle.width,
        width = _imageWrapperStyle$wi === void 0 ? '100%' : _imageWrapperStyle$wi,
        _imageWrapperStyle$he = imageWrapperStyle.height,
        height = _imageWrapperStyle$he === void 0 ? 'auto' : _imageWrapperStyle$he;
    var blockDownloadStyles = utils.isiOS() && !this.props.styleParams.allowDownload ? {
      color: 'green',
      '-webkit-user-select': 'none',
      '-webkit-touch-callout': 'none'
    } : {};
    return _objectSpread(_objectSpread({
      width: width,
      height: height
    }, blockDownloadStyles), this.createImageBorder());
  };

  _proto.createImageBorder = function createImageBorder() {
    var styles = this.props.styles;

    if (styles.imageInfoType !== GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND) {
      return {
        boxSizing: 'border-box',
        borderStyle: 'solid',
        borderWidth: styles.itemBorderWidth,
        borderColor: styles.itemBorderColor.value,
        borderRadius: styles.itemBorderRadius
      };
    }
  } // #endregion
  // #region Helper functions
  ;

  _proto.createLinkParams = function createLinkParams(item) {
    var _this$props3 = this.props,
        noFollowForSEO = _this$props3.noFollowForSEO,
        styles = _this$props3.styles;
    var itemClick = styles.itemClick;
    var directLink = item.directLink;

    var _ref2 = directLink || {},
        url = _ref2.url,
        target = _ref2.target;

    var isSEO = isSEOMode();
    var shouldUseNofollow = isSEO && noFollowForSEO;
    var seoLinkParams = shouldUseNofollow ? {
      rel: 'nofollow'
    } : {};
    var shouldUseDirectLink = !!(url && target && itemClick === GALLERY_CONSTS.itemClick.LINK);
    var linkParams = shouldUseDirectLink ? _objectSpread({
      href: url,
      target: target
    }, seoLinkParams) : false;
    return linkParams;
  };

  _proto.measureIfNeeded = function measureIfNeeded(node) {
    var styles = this.props.styles;

    if (!this.node && node) {
      this.node = node;
    }

    if (this.node && this.node.clientWidth !== this.clientWidth) {
      this.clientWidth = this.node.clientWidth;
      this.setState({
        itemStyle: {
          width: this.clientWidth,
          height: Math.round(this.clientWidth / styles.cubeRatio)
        }
      });
    }
  };

  _proto.fixStylesIfNeeded = function fixStylesIfNeeded(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      externalInfoHeight: styles.textBoxHeight
    });
  };

  _proto.isMetadataLinkExists = function isMetadataLinkExists(item) {
    var metadata = item.metadata || item.metaData;
    return metadata && metadata.link ? true : false;
  };

  _proto.eventsListener = function eventsListener(eventName, eventData) {
    if (typeof this.props.eventsListener === 'function') {
      this.props.eventsListener(eventName, eventData);
    }
  } // #endregion
  ;

  _proto.render = function render() {
    var _this2 = this;

    var eventsListener = this.eventsListener,
        props = this.props;
    var customInfoRenderer = props.customInfoRenderer,
        items = props.items;
    var styles = this.fixStylesIfNeeded(props.styles);
    var itemClick = styles.itemClick;
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "lean-gallery",
      className: ['pro-gallery', 'inline-styles', 'lean-gallery-gallery'].join(' '),
      style: this.createGalleryStyle()
    }, items.map(function (item, itemIdx) {
      var linkParams = _this2.createLinkParams(item);

      var clickable = linkParams && itemClick === GALLERY_CONSTS.itemClick.LINK || [GALLERY_CONSTS.itemClick.EXPAND, GALLERY_CONSTS.itemClick.FULLSCREEN].includes(itemClick) || _this2.isMetadataLinkExists(item);

      var itemData = _objectSpread(_objectSpread({}, item), {}, {
        id: item.itemId,
        idx: itemIdx
      });

      var metadata = item.metaData || item.metadata;

      var itemProps = _objectSpread(_objectSpread(_objectSpread({}, itemData), metadata), {}, {
        style: _this2.state.itemStyle,
        styleParams: styles
      });

      var imageWrapperStyle = _this2.createImageWrapperStyle(item);

      var infoHeight = styles.textBoxHeight;

      var texts = function texts(placement) {
        return typeof customInfoRenderer === 'function' && styles.titlePlacement === placement && /*#__PURE__*/React.createElement("div", {
          className: "gallery-item-common-info gallery-item-" + (placement === GALLERY_CONSTS.placements.SHOW_ABOVE ? "top" : "bottom") + "-info",
          style: getInnerInfoStyle(placement, styles, infoHeight)
        }, customInfoRenderer(itemProps, placement));
      };

      return /*#__PURE__*/React.createElement("a", _extends({
        className: ['gallery-item-container', 'lean-gallery-cell'].join(' '),
        style: _this2.createItemContainerStyle(clickable, item),
        ref: function ref(node) {
          _this2.measureIfNeeded(node);

          eventsListener(GALLERY_CONSTS.events.ITEM_CREATED, itemData);
        },
        key: 'item-container-' + itemIdx
      }, linkParams), texts(GALLERY_CONSTS.placements.SHOW_ABOVE), /*#__PURE__*/React.createElement("div", {
        style: imageWrapperStyle,
        className: ['gallery-item-hover', 'lean-gallery-image-wrapper'].join(' '),
        onClick: function onClick() {
          return eventsListener(GALLERY_CONSTS.events.ITEM_ACTION_TRIGGERED, itemData);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: _this2.resizeUrl({
          item: item
        }),
        loading: "lazy",
        className: ['gallery-item-content', 'lean-gallery-image'].join(' '),
        alt: get(item, 'title'),
        style: _this2.createImageStyle(imageWrapperStyle),
        onLoad: function onLoad() {
          return eventsListener(GALLERY_CONSTS.events.ITEM_LOADED, itemData);
        }
      })), texts(GALLERY_CONSTS.placements.SHOW_BELOW));
    }));
  };

  return LeanGallery;
}(React.Component);

export { LeanGallery as default };

var get = function get(item, attr) {
  if (typeof item[attr] !== 'undefined') {
    return item[attr];
  }

  var metadata = item.metadata || item.metaData;

  if (typeof metadata !== 'undefined') {
    if (typeof metadata[attr] !== 'undefined') {
      return metadata[attr];
    }
  }
};

export var formatLeanGalleryStyles = function formatLeanGalleryStyles(styles) {
  return processLayouts(addPresetStyles(styles)); // TODO make sure the processLayouts is up to date. delete addLayoutStyles from layoutsHelper when done with it...
};